import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

export interface PlayVideoPayload {
    url: string;
    title: string;
}

@Injectable({
    providedIn: 'root'
})
export class VideoService implements OnDestroy {

    /** Emits whenever the IndusLabs agent (or a dev test) requests a video to be played. */
    playVideo$ = new Subject<PlayVideoPayload>();

    private boundWindowHandler: (e: Event) => void;

    constructor(private zone: NgZone) {
        // Fallback: allow DevTools / external scripts to trigger the video modal via:
        //   window.dispatchEvent(new CustomEvent('induslabs_play_video', {
        //     detail: { url: 'https://www.youtube.com/embed/AReS4wqP0WE', title: 'Panel Video 2026' }
        //   }));
        this.boundWindowHandler = (e: Event) => {
            const detail = (e as CustomEvent<PlayVideoPayload>).detail;
            if (detail?.url) {
                this.zone.run(() => {
                    this.playVideo$.next({
                        url: detail.url,
                        title: detail.title || 'Video'
                    });
                });
            }
        };
        window.addEventListener('induslabs_play_video', this.boundWindowHandler);
    }

    /**
     * Trigger the video modal programmatically (called from LiveKit DataReceived handler).
     */
    triggerPlay(url: string, title: string = 'Video'): void {
        this.zone.run(() => {
            this.playVideo$.next({ url, title });
        });
    }

    ngOnDestroy(): void {
        window.removeEventListener('induslabs_play_video', this.boundWindowHandler);
        this.playVideo$.complete();
    }
}
